<template>
  <div class="component-orderItem">
    <div class="order-head" @click="handleClickOrderItem()">
      <span>{{orderItem.orderType}}</span>
      <span class="order-status">{{orderItem.orderState}}</span>
    </div>
    <div class="order-info">
      <div class="pic-wrap" @click="handleClickOrderItem()">
        <img class="pic" :src="formatHttpImg(orderItem.goodsImg)" />
      </div>
      <div class="content">
        <div class="goods-name" @click="handleClickOrderItem()">{{orderItem.goodsName}}</div>
        <div class="pay-time" @click="handleClickOrderItem()">付款日 {{orderItem.payTime}}</div>
        <div class="order-no" >
          <span @click="handleClickOrderItem()">订单号 {{orderItem.orderNo}}</span>
          <span
            class="btn-copy-orderNo"
            :data-clipboard-text="orderItem.orderNo"
          >复制</span>
        </div>
        <div class="price" @click="handleClickOrderItem()">
          <span>付款 ¥{{orderItem.totalPrice}}</span>
          <div class="share-money" v-if="false && orderItem.sharePrice">
            <span>推广收益</span>
            <span class="unit">¥</span>
            <span class="money">{{orderItem.sharePrice}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// const orderItem = {
//   orderState: '失效',
//   orderType: '天猫',
//   orderNo: '694655938387710460',
//   goodsId: 572102388072,
//   goodsName: '瑜伽垫初学者女士加厚防滑垫子男士加宽长无味瑜珈健身垫三件套装',
//   goodsImg: 'http://img.alicdn.com/bao/uploaded/i1/2013961428/O1CN01Bwajlu1MQ498sGSBb_!!2013961428.jpg',
//   payTime: '2019-11-04 09:58:26',
//   totalPrice: 13.8,
//   sharePrice: 0,
// }
import Clipboard from 'clipboard'
import { Toast } from 'mand-mobile'
export default {
  name: 'orderItem',
  props: {
    orderItem: {
      type: Object,
      default: function() {
        return {}
      },
    },
    channel: {
      type: String,
      default: 'tbk'
    },
  },
  data() {
    return {}
  },
  mounted() {
    const clipboard = new Clipboard('.btn-copy-orderNo')
    clipboard.on('success', e => {
      Toast.succeed('订单号复制成功', 1500)
      e.clearSelection()
    })
  },
  created() {},
  methods: {
    handleClickOrderItem() {
      if (this.channel !== 'tbk') {
        this.$router.push({ name: 'productDetail', query: { goodsId: this.orderItem.goodsId, channel: this.channel } })
      }
    },
  },
}
</script>

<style  lang="scss" scoped>
.component-orderItem {
  background: #fff;
  box-sizing: border-box;
  padding: 0 0.2rem 0.2rem;
  border-radius: 0.1rem;
  &:not(:last-child) {
    margin-bottom: 0.12rem;
  }
  .order-head {
    display: flex;
    align-items: center;
    height: 0.6rem;
    color: #333;
    font-weight: 500;
    padding-right: 0.1rem;
    .order-status {
      margin-left: auto;
      color: #999;
      font-weight: 400;
      font-size: 0.26rem;
    }
  }
  .order-info {
    position: relative;
    display: flex;
    margin-top: 0.1rem;
    .pic-wrap {
      width: 2rem;
      height: 2rem;
      .pic {
        width: 100%;
        height: 100%;
        border-radius: 0.08rem;
      }
    }
    .content {
      position: relative;
      height: 2rem;
      flex: 1;
      margin-left: 0.2rem;
      min-width: 0; // 解决flex遇上white-space: nowrap引起样式冲突
      .goods-name {
        position: relative;
        height: 0.4rem;
        line-height: 0.4rem;
        color: #333;
        font-size: 0.28rem;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .pay-time {
        margin-top: 0.16rem;
        color: #999;
        font-size: 0.2rem;
      }
      .order-no {
        margin-top: 0.2rem;
        color: #999;
        font-size: 0.2rem;
        display: flex;
        align-items: center;
        height: 0.24rem;
        .btn-copy-orderNo {
          display: inline-block;
          margin-left: 0.04rem;
          border: 1px solid #999;
          border-radius: 0.16rem;
          padding: 0.02rem 0.12rem;
          cursor: pointer;
          &:active {
            opacity: 0.5;
          }
        }
      }
      .price {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 0.4rem;
        display: flex;
        align-items: center;
        color: #333;
        padding-right: 0.1rem;
        font-size: 0.22rem;
        .share-money {
          margin-left: auto;
          color: #f42f19;
          display: flex;
          align-items: center;
          height: 0.4rem;
          .unit {
            margin: 0 0.06rem;
          }
          .money {
            display: inline-block;
            font-size: 0.36rem;
            font-weight: 600;
            margin-top: -0.04rem;
          }
        }
      }
    }
  }
}
</style>